export default __webpack_public_path__ + "static/media/checkIcon.184ddd68.svg";